/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';

import {
    BaseComp,
  BaseContent,
  DivSwiper,
  NewsDiv,
  TextBody,
  TextTitle,
} from './styles';
import Services from '../../../../../services/service';
import { Container, Content } from '../../../../../styles/components';

import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useMediaQuery } from '@mui/material';

interface Medias {
  media_id: number;
  media_url: string;
  permalink: string;
}

const News: React.FC = () => {
  const [medias, setMedias] = useState<Medias[]>([]);
  const [mobileMedias, setMobileMedias] = useState<Medias[]>([]);
  const services = { service: new Services() };

  const matches = useMediaQuery('(max-width:1000px)');

  const matches2 = useMediaQuery('(max-width:800px)');

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
  };

  useEffect(() => {
    async function getMedias() {
      try {
        const response = await services.service.getMedias();
        console.log(response);
        setMedias(response.data.results.slice(0, 24));
        setMobileMedias(response.data.results.slice(0, 5));
      } catch (err) {
        console.error(err);
      }
    }
    getMedias();
  }, []);

  const handleLink = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <BaseComp id='news'>
        <BaseContent>
            <NewsDiv>
                <TextBody>
                    <TextTitle>
                        <h1>Fique por dentro!</h1>
                    </TextTitle>
                    <p>
                    Acompanhe nossas Redes Sociais e fique por dentro de todas as
                    novidades e informações do transporte coletivo de BH!
                    </p>
                </TextBody>
            </NewsDiv>
            <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                spaceBetween={2}
                slidesPerView={matches2 ? 1 : matches ? 2 : 4}
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 1500,
                    disableOnInteraction: true,
                }}
                style={{
                    display: 'flex',
                    textAlign: 'center',
                    maxWidth: '100%',
                    height: '400px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                {medias.map((data:any, index: number) => (
                    <SwiperSlide
                        key={index}
                        style={{
                            width: matches2 ? '50%' : matches ? '50%' : '70%',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <a href={data?.permalink} target='_blank'>
                            <DivSwiper>
                                <img src={data?.media_url} width={matches2 ? 200 : matches ? 200 : 220 }/>
                                <p>Data da publicação: {data?.publication_date}</p>

                            </DivSwiper>
                            
                        </a>
                    </SwiperSlide>
                ))}
            </Swiper>
        </BaseContent>
    </BaseComp>
  );
};

export default News;
